
import React, { Fragment } from "react";
import { useMemo } from "react";
import { useFormDefinition } from "../../data/context/useFormType";
import IFormDefinition from "../../interfaces/IFormDefinition";

type IRenderProps = { formDefinition: IFormDefinition | null; schemaOk: boolean };

interface RenderFormDefinitionProps {
    search: { formDefinition: string | number };
    validateSchema?: (schema: IFormDefinition["schema"]) => boolean;
    render: (props: IRenderProps) => any;
};

export const RenderFormDefinition: React.FC<RenderFormDefinitionProps> = ({ search, validateSchema, render }) => {
    const { data: formDefinition } = useFormDefinition(search.formDefinition);

    const schemaOk = useMemo(() => {
        if (validateSchema && formDefinition) {
            return validateSchema(formDefinition.schema)
        }
        return Boolean(formDefinition?.schema);
    }, [formDefinition, validateSchema]);

    return (
        <Fragment>
            {render({ formDefinition, schemaOk })}
        </Fragment>
    );
};